import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import AuthApi from '../../api/platform/authApi';
import { useSystemError } from '../../components/Error/SystemErrorContext';
import { ResponseErrorModel } from '../../models/system/responseErrorModel';
import { ResponseSuccessModel } from '../../models/system/responseSuccessModel';
import { handleError, mapResponseErrorToSystemError, mapUnknownErrorToSystemError } from '../../utils/errorUtils';

const EmailUpdateVerificationPage: React.FC = () => {
    const [message, setMessage] = useState<string | null>(null);
    const [loading, setLoading] = useState(true);
    const [searchParams] = useSearchParams();
    const auth_code = searchParams.get('auth_code'); // Get auth_code from URL
    const navigate = useNavigate();
    const [didErrorOccur, setDidErrorOccur] = useState(false);
    const { triggerSystemError } = useSystemError();

    useEffect(() => {
        const fetchVerifyEmailUpdate = async () => {
            try {
                if (!auth_code) {
                    setMessage('Invalid request, no authorization code provided.');
                    setLoading(false);
                    return;
                }

                const response = await AuthApi.updateEmail(auth_code);
                if (response.success) {
                    const data = (response as ResponseSuccessModel).data;
                    navigate(`/auth/message/${data.auth_type}`);
                } else {
                    handleError(mapResponseErrorToSystemError(response as ResponseErrorModel), setMessage, setDidErrorOccur, triggerSystemError);
                }
            } catch (error) {
                handleError(mapUnknownErrorToSystemError(error, false), setMessage, setDidErrorOccur, triggerSystemError);
            } finally {
                setLoading(false);
            }
        };

        fetchVerifyEmailUpdate();
    }, [auth_code]);

    const handleRedirect = () => {
        navigate('/auth/message/email-update-verification');
    };

    if (loading) return <div>Loading...</div>;

    return (
        <div>
            <h2>Email Update Status</h2>
            <p>{message}</p>
            <button onClick={handleRedirect}>Go to Message Page</button>
        </div>
    );
};

export default EmailUpdateVerificationPage;
